import React from 'react';

export default function ({ children, className }) {
  return <a href={`mailto:${children}`} className={className}>{children}</a>;
}
